import type { RuleSet } from 'styled-components';

import styled, { css } from 'styled-components';

import { media } from '../../../../shared/core/styles';
import { SiteType } from '~/utilities/graphql/codegen';

const AafSizesWrapperStyle = css`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

const GstarSizesWrapperStyle = css`
  display: grid;
  grid-auto-flow: column;
  opacity: 0;
`;

const GstarSizeWrapperStyles = css`
  margin: ${({ theme }) => theme.spacing.y.lg} 0 12px;

  @media ${({ theme }) => media(theme).greaterThan('sm')} {
    margin-top: 32px;
  }
`;
const AafSizeWrapperStyles = css`
  margin: ${({ theme }) => theme.spacing.y.md} 0;
`;

const SizesWrapperStylesConfig: Record<SiteType, RuleSet> = {
  [SiteType.Gstar]: GstarSizesWrapperStyle,
  [SiteType.Wahts]: GstarSizesWrapperStyle,
  [SiteType.Outlet]: GstarSizesWrapperStyle,
  [SiteType.Employeeshop]: GstarSizesWrapperStyle,
  [SiteType.Aaf]: AafSizesWrapperStyle,
};

const SizeWrapperStylesConfig: Record<SiteType, RuleSet> = {
  [SiteType.Gstar]: GstarSizeWrapperStyles,
  [SiteType.Wahts]: GstarSizeWrapperStyles,
  [SiteType.Outlet]: GstarSizeWrapperStyles,
  [SiteType.Employeeshop]: GstarSizeWrapperStyles,
  [SiteType.Aaf]: AafSizeWrapperStyles,
};

export const S = {
  Wrapper: styled.div``,

  SizeWrapper: styled.div`
    ${({ theme }) => SizeWrapperStylesConfig[theme.siteType]}
  `,

  SizeWrapperHeader: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  `,

  Sizes: styled.div`
    ${({ theme }) => SizesWrapperStylesConfig[theme.siteType]}
  `,
};
